module.exports = __webpack_public_path__ + "ffb7efefe00176e4a8a90f5c9a763806.pdf";